// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"39":"98bc6578f8564d5d","888":"26ab164beffb0e35"}[chunkId] + ".css";
};